import React, { memo } from 'react';
import './Styles.css';
import CareOfFields from '../CommonFields/CareOfFields/CareOfFields';
import AddressCountrySelector from '../CommonFields/AddressCountrySelector';
import { formatMessage } from '../../../../Localization/formatMessage';
import Messages from '../../../../Localization/Messages';
import TextInput from '../../../ids/InputElements/TextInput';

const ForeignAddress = ({ getCommonFields, modalMode, addressState, setAddressState, countryList }) => {
  return (
    <>
      <CareOfFields modalMode={modalMode} addressState={addressState} setAddressState={setAddressState} />

      <TextInput
        label={formatMessage(Messages.addressInfo_addressLine, {
          lineNumber: 1,
        })}
        {...getCommonFields('addressLine1', true)}
        cssClasses="formatSwitcher-foreign-input"
      />

      <TextInput
        label={formatMessage(Messages.addressInfo_addressLine, {
          lineNumber: 2,
        })}
        {...getCommonFields('addressLine2')}
        cssClasses="formatSwitcher-foreign-input"
      />

      <TextInput
        label={formatMessage(Messages.addressInfo_addressLine, {
          lineNumber: 3,
        })}
        {...getCommonFields('addressLine3')}
        cssClasses="formatSwitcher-foreign-input"
      />

      <TextInput
        label={formatMessage(Messages.addressInfo_city)}
        {...getCommonFields('city')}
        cssClasses="formatSwitcher-foreign-city"
      />

      <AddressCountrySelector addressState={addressState} countryList={countryList} setAddressState={setAddressState} />
    </>
  );
};

export default memo(ForeignAddress);
